import { type ContentMedium } from '@prisma/client';

const label: Record<ContentMedium, string> = {
  IMAGE_OCR_TEXT: '',
  IMAGE_DENSE_CAPTION: '',
  IMAGE_QUERY: '',
  TEXT: 'Text',
  VIDEO_UNIQUE_OCR_TEXT: 'Video',
  VIDEO_TRANSCRIPT: 'Audio',
  WEB_HIDDEN_TEXT: 'Hidden on Webpage',
};

export function getContentMediumLabel(contentMedium: ContentMedium) {
  return label[contentMedium] || '';
}

type FeedbackLocationProps = {
  contentMedium: ContentMedium;
};

export default function FeedbackSource({ contentMedium }: FeedbackLocationProps) {
  const text = getContentMediumLabel(contentMedium);
  if (!text) return null;
  return <span className="text-muted-foreground text-[11px]">{text}</span>;
}
